export default __webpack_public_path__ + "static/media/novelties-center-guide.904108a7.png";